import React, { FC } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

interface SkeletonLoaderProps {
  count?: number;
  height?: number | string;
  width?: number | string;
  maxWidth?: number | string;
  single?: boolean;
  horizontal?: boolean;
  borderRadius?: number | string;
}

export const SkeletonLoader: FC<SkeletonLoaderProps> = ({ count = 2, height = 40, width, maxWidth, horizontal, single, borderRadius }) => {
  return (
    <Stack
      spacing={2}
      direction={single && horizontal ? 'row' : 'column'}
      sx={{
        alignItems: "stretch",
        width: "100%",
        height: height,
      }}>
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            gap: 2,
          }}
        >
          {single ? (
            <Skeleton
              variant="rectangular"
              height={height}
              sx={{
                width: width || '100%',
                height: height || '100%',
                maxWidth: width || '100%',
                flexGrow: 1,
                borderRadius: borderRadius,
              }}
            />
          ) : (
            <>
              <Skeleton variant="rectangular" height={height} sx={{ flexGrow: 1, width: width || 'auto' }} />
              <Skeleton variant="rectangular" width={40} height={height} />
            </>
          )}
        </Box>
      ))}
    </Stack>
  );
};
